import { createContext } from 'react';

// {items, loading} - see PendingApprovalsProvider.jsx for the actual
// fetch/WS/notification logic. Split into its own file the same way
// AuthContext.jsx/DetailsContext.jsx are, so any component can import just
// the context without pulling in the provider's implementation.
const PendingApprovalsContext = createContext({ items: [], loading: true });

export default PendingApprovalsContext;
